export default __webpack_public_path__ + "assets/fahrenheit.9f35fa2f.svg";